import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule, LazyImport, registerLazyOrchestrator } from "owa-bundling";
import { onItemPartDeselected } from "owa-mail-actions/lib/readingPaneActions";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MarkRead"*/ "./lazyIndex"), {
    name: "MarkRead",
});

export const lazyClearAutoMarkAsReadTimer: LazyAction<typeof lazyIndex.clearAutoMarkAsReadTimerMutator, typeof lazyModule> = new LazyAction(lazyModule, m => m.clearAutoMarkAsReadTimerMutator);
export const lazySetAutoMarkAsReadTimer: LazyAction<typeof lazyIndex.setAutoMarkAsReadTimer, typeof lazyModule> = new LazyAction(lazyModule, m => m.setAutoMarkAsReadTimer);

export const lazyToggleRowReadState: LazyAction<typeof lazyIndex.toggleRowReadState, typeof lazyModule> = new LazyAction(lazyModule, m => m.toggleRowReadState);

export const lazyMarkItemsAsReadBasedOnNodeIds: LazyAction<typeof lazyIndex.markItemsAsReadBasedOnNodeIds, typeof lazyModule> = new LazyAction(lazyModule, m => m.markItemsAsReadBasedOnNodeIds);

export const lazyMarkItemAsReadFromReadingPane: LazyAction<typeof lazyIndex.markItemAsReadFromReadingPane, typeof lazyModule> = new LazyAction(lazyModule, m => m.markItemAsReadFromReadingPane);

export const lazyOnKeyboardMarkAsRead: LazyAction<typeof lazyIndex.onKeyboardMarkAsRead, typeof lazyModule> = new LazyAction(lazyModule, m => m.onKeyboardMarkAsRead);

export const lazyMarkAsReadInTable: LazyAction<typeof lazyIndex.markAsReadInTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.markAsReadInTable);

export const lazyOnSingleSelectionChanged: LazyAction<typeof lazyIndex.onSingleSelectionChanged, typeof lazyModule> = new LazyAction(lazyModule, m => m.onSingleSelectionChanged);

export const lazyOnItemPoppedOut: LazyAction<typeof lazyIndex.onItemPoppedOut, typeof lazyModule> = new LazyAction(lazyModule, m => m.onItemPoppedOut);

export const lazyMarkReadOnTableViewChange: LazyImport<typeof lazyIndex.markReadOnTableViewChange, typeof lazyModule> = new LazyImport(lazyModule, m => m.markReadOnTableViewChange);

export const lazyOnReadingPaneClosed: LazyAction<typeof lazyIndex.onReadingPaneClosed, typeof lazyModule> = new LazyAction(lazyModule, m => m.onReadingPaneClosed);
export const lazyOnNavigateAwayViaUpDown: LazyAction<typeof lazyIndex.onNavigateAwayViaUpDown, typeof lazyModule> = new LazyAction(lazyModule, m => m.onNavigateAwayViaUpDown);

export const lazyMarkItemsAsReadUsingItemIds: LazyAction<typeof lazyIndex.markItemsAsReadUsingItemIds, typeof lazyModule> = new LazyAction(lazyModule, m => m.markItemsAsReadUsingItemIds);

registerLazyOrchestrator(onItemPartDeselected, lazyModule, m => m.onItemPartDeselectedOrchestrator);
